import { config } from "~/data/config";

export const razorpayTDConfig = {
  onlyCardConfigForTD: {
    config: {
      display: {
        blocks: {
          block1: {
            name: "Pay through Cards",
            instruments: [
              {
                method: "card",
                ...(config.env === "Prod"
                  ? { iins: ["652926", "652925", "402219", "402359"] }
                  : {}),
              },
            ],
          },
        },
        sequence: ["block.block1"],
        preferences: {
          show_default_blocks: false,
        },
      },
    },
  },
  options: {
    key: config.tdSubscriptionRazorpayKey,
    recurring: "1",
  },
};
